// extracted by mini-css-extract-plugin
export default {"App":"App_App__NVQnm","App-logo":"App_App-logo__oSAkh","App-logo-spin":"App_App-logo-spin__h2OdH","App-header":"App_App-header__VZuSW","App-link":"App_App-link__baxYS"};